import React, { useContext } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
// Import Contexts
import auth from 'shared-components/src/utils/auth';
import { ServiceConfigContext } from '../../context/ServiceConfigContext';
import { RoleContext } from '../../context/RoleContext';
// Import Utils

function CustomRoute({
  priv = false,
  authorize = false,
  allowedRoles = [],
  service,
  reedemPayoutPage,
  element,
  children,
  ...props
}) {
  const location = useLocation();
  const serviceConfiguration = useContext(ServiceConfigContext);
  const userRole = useContext(RoleContext);

  const isAuthenticated = !!auth.isAuthenticated();
  const notAuthorized = authorize && !allowedRoles.includes(userRole);

  // Checks for Authentication and redirects to login if not authenticated
  if (priv && !isAuthenticated) return <Navigate to="/auth/login" replace />;

  // If on a pre-authenticated page and authenticated, redirect to homepage
  // Exception: Allow access to MFA setup/verify pages even when authenticated
  const isMFAPage = location?.pathname?.includes('/mfa-setup') || location?.pathname?.includes('/mfa-verify');
  if (!priv && isAuthenticated && !reedemPayoutPage && !isMFAPage) return <Navigate to="/" replace />;

  // Check for Authorization
  // Check if user role is allowed to access the page
  if (notAuthorized) return <Navigate to="/" replace />;

  // Check if service they're trying to access is configured for their company
  if (service && !serviceConfiguration[service]) return <Navigate to="/" replace />;

  // Return the element or children
  return element || children || null;
}

export default CustomRoute;
